import ExaminationRoom from './ExaminationRoom';

export default ExaminationRoom;
